/* eslint-disable no-template-curly-in-string */
import Grid from 'UIKit/Box/Grid'
import { DailyRewardPackageCode } from 'config/constants/dailyReward'
import useDetectComponentOnScreen from 'hooks/useDetectComponentOnScreen'
import { ColumnCenter } from 'layout/Components/Column'
import { useEffect } from 'react'
import { useDailyRewardPackage, useTodayRewards } from 'state/bonus/hooks/dailyReward'
import RewardCard from './RewardCard'

const DailyCheckinRewards: React.FC<{ packageCode: DailyRewardPackageCode }> = ({ packageCode }) => {
  const dailyRewardPackage = useDailyRewardPackage(packageCode)
  const { currentRewards } = useTodayRewards()

  const currentReward = currentRewards?.find((item) => item.packageCode === packageCode)

  const { ref } = useDetectComponentOnScreen({ root: null })

  useEffect(() => {
    ref.current?.scrollIntoView()
  }, [currentReward])

  return (
    <ColumnCenter>
      <Grid
        gridTemplateColumns={['1fr 1fr 1fr 1fr', '1fr 1fr 1fr 1fr', '1fr 1fr 1fr 1fr']}
        width="100%"
        gridColumnGap="8px"
        gridRowGap="16px"
        mb="20px !important"
        maxHeight="246px"
        overflowY="scroll"
        overflowX="hidden"
      >
        {dailyRewardPackage.rewards.map((item) => {
          return (
            <RewardCard
              key={`${packageCode}-${item.id}`}
              rewardDetail={item}
              isActive={currentReward.reward?.id === item.id}
              isHighlight={item.isHighlight}
              refReward={item.id === currentReward.reward?.id ? ref : null}
            />
          )
        })}
      </Grid>
    </ColumnCenter>
  )
}

export default DailyCheckinRewards
